export default "__VITE_ASSET__ed3fc04d__"